import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent extends DialogBase implements OnInit {

  id: any;
  title: any;
  text: any;

  ngOnInit(): void {
  }

  save() {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }
}
